import type { SxProps } from "@mui/material"

const contextContainer: SxProps = {
  display: "flex",
  flexDirection: "row",
  flex: 1,
  overflow: "hidden"
}

const contentAreaContainer: SxProps = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  width: "100%",
  overflow: "hidden"
}

export default {
  contextContainer,
  contentAreaContainer
}
